import { render, staticRenderFns } from "./UniRequestDetails.vue?vue&type=template&id=c9430bb8&scoped=true&"
import script from "./UniRequestDetails.vue?vue&type=script&lang=js&"
export * from "./UniRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./UniRequestDetails.vue?vue&type=style&index=0&id=c9430bb8&prod&lang=scss&"
import style1 from "./UniRequestDetails.vue?vue&type=style&index=1&id=c9430bb8&prod&lang=scss&scoped=true&"
import style2 from "./UniRequestDetails.vue?vue&type=style&index=2&id=c9430bb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9430bb8",
  null
  
)

export default component.exports